const formatMembershipData = ({ id, firstName, lastName, emailAddress }) => {
  return {
    id,
    full_name: `${firstName} ${lastName}`,
    email: emailAddress
  }
}
export { formatMembershipData }
